import * as userConstants from '../constants/user';

export default function currentUser(state = { loading: true }, action) {
    switch (action.type) {
        case userConstants.FETCH_ME_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case userConstants.FETCH_ME_SUCCESS:
            return {
                ...state,
                id: action.payload.id,
                loading: false,
            };
        case userConstants.FETCH_ME_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
            };
        case userConstants.SIGN_OUT_REQUEST:
            return {
                ...state,
                signingOut: true,
                error: true,
            };
        case userConstants.SIGN_OUT_FAILURE:
            return {
                ...state,
                signingOut: false,
                error: true,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/currentUserReducer.js